/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: [],
  error: null,
  loading: false,
  loaded: false,
  total: 0,
  analyticsRestrictionList: [],
  successResponse: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ANALYTICS: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_ANALYTICS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.payload,
      };
    }
    case types.FETCH_ANALYTICS_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }

    case types.FETCH_A_ANALYTIC: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.FETCH_A_ANALYTIC_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        entities: {
          ...state.entities,
          [action.payload.playerId]: action.payload,
        },
      };
    }
    case types.FETCH_A_ANALYTIC_FAILED: {
      /* istanbul ignore next */
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.FETCH_ANALYTICS_RESTRICTION_LIST: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_ANALYTICS_RESTRICTION_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        analyticsRestrictionList: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.FETCH_ANALYTICS_RESTRICTION_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }

    case types.CLEAR_ANALYTICS_RESTRICTION_LIST: {
      return {
        ...state,
        loading: false,
        loaded: false,
        analyticsRestrictionList: [],
        successResponse: null,
      };
    }
    case types.CLEAR_ANALYTICS_LIST: {
      return {
        ...state,
        loading: false,
        loaded: false,
        list: [],
      };
    }
    case types.CREATE_ANALYTICS_RESTRICTION: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.CREATE_ANALYTICS_RESTRICTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    case types.CREATE_ANALYTICS_RESTRICTION_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    case types.DELETE_ANALYTICS_RESTRICTION: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case types.DELETE_ANALYTICS_RESTRICTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    case types.DELETE_ANALYTICS_RESTRICTION_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    default:
      return state;
  }
}
